import { render, staticRenderFns } from "./BaseStationsList.vue?vue&type=template&id=2d113b38&scoped=true&"
import script from "./BaseStationsList.vue?vue&type=script&lang=ts&"
export * from "./BaseStationsList.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStationsList.vue?vue&type=style&index=0&id=2d113b38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d113b38",
  null
  
)

export default component.exports